// Tipo TypeScript inferido del schema
import { z } from "zod";

export const signInFormSchema = z.object({
  name: z.string({ required_error: "Este campo es requerido" }),
  last_name: z.string({ required_error: "Este campo es requerido" }),
  username: z.string({ required_error: "Este campo es requerido" }),
  email: z.string({ required_error: "Este campo es requerido" }).email({
    message: "Ingrese un correo electrónico válido",
  }),
});
